import { jsx as _jsx } from "react/jsx-runtime";
import { useDeviceConfig } from 'console/shared/contexts/device/config';
import { memo, useContext, useEffect, useMemo } from 'react';
import { LegacyHeatingCircuitProvider } from './legacy';
import { Z3KHeatingCircuitProvider } from './z3k';
import { isPropsEqual } from 'console/shared/utils/memo';
import { AnimatePresence } from 'framer-motion';
import * as S from '../styles';
import { HeatingCircuitContent } from './types';
import { useBooleanState } from 'shared/hooks/state/boolean';
const transition = {
    duration: 0.2,
};
const transition_variants = {
    initial: {
        opacity: 0,
    },
    animate: {
        opacity: 1,
        transition,
    },
    exit: {
        opacity: 0,
    },
};
export const HeatingCircuitProvider = memo(function HeatingCircuitProvider(props) {
    const { children, config, lazy } = props;
    const { is_legacy_device } = useDeviceConfig();
    const Provider = useMemo(() => is_legacy_device ? LegacyHeatingCircuitProvider : Z3KHeatingCircuitProvider, [is_legacy_device]);
    // был нужен для задержки рендеринга {is_loaded && heating_circuit}
    const [is_loaded, , setIsLoaded] = useBooleanState(false);
    useEffect(() => {
        if (lazy) {
            const lazy_id = setTimeout(setIsLoaded, 450);
            return () => clearTimeout(lazy_id);
        }
        setIsLoaded();
        return;
    }, [lazy]);
    const lazy_children = useMemo(() => (_jsx(S.CircuitTransition, { initial: "initial", animate: "animate", exit: "exit", variants: transition_variants, children: children })), [children]);
    const heating_circuit = useMemo(() => (lazy ? lazy_children : children), [lazy, lazy_children, children]);
    return (_jsx(Provider, { config: config, lazy: lazy, children: _jsx(AnimatePresence, { exitBeforeEnter: true, initial: false, children: heating_circuit }) }));
}, isPropsEqual);
export const useHeatingCircuit = () => useContext(HeatingCircuitContent);
